import useLevelSelection from "../../utils/hooks/useLevelSelection.js";
import  React, { useState, useEffect, useMemo, useContext} from "react";
import { Link, NavLink, useParams} from "react-router-dom";
import "./Content.scss";
import { slugify } from "../../utils/slugify.js";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "../../utils/hooks/translateHook.js";
import { useLevelContentData } from "../../utils/hooks/translateLevelContentDataHook.js";
import { CurrentUserContext } from "../../context/CurrentUserContext";
import LectureProgressItem from "./LectureProgressItem.jsx"
import Favlogo from './styles/icon/FAVICON.png';
import placeholderMain from "./images/content_big_1440.png";
import placeholderSide from "./images/content_1440.png";
import arrowRight from './styles/icon/arrowRight.svg';
import { courseRegistry } from "../../courses/courseRegistry.js";
import html from "./config.js";
 

const lang = "tr";
const Content = ({ user, setCurrentUser, courseProgress = [], setCourseProgress = () => {} }) => {
  const [openTreeIndex, setOpenTreeIndex] = useState(null); //I am thinking on using side panel - top just profile in small - will be enlarged or a modal open for changing user details  
  const [selectedSubjectIdx, setSelectedSubjectIdx] = useState(null);
  const [selectedType, setSelectedType] = useState(null);
  const { currentUser } = useContext(CurrentUserContext);
  const navigate = useNavigate();
  const { courseSlug} = useParams();
  const courseConfig = courseRegistry[courseSlug];
  const t = useTranslation();
  const rawLevelContentData = useMemo(
    () => courseConfig?.levelContentData || [],
    [courseConfig]
  );

  const translatedData =
    useLevelContentData(rawLevelContentData, courseSlug) || [];

  const activeUser = user || currentUser;

  const {
    selectedLevel,
    mergedForSelected,
    userLevelContent
  } = useLevelSelection(
    activeUser,
    translatedData,
    courseSlug
  );
 
  const levelData = mergedForSelected?.subjects?.map(s => s.title) || [];
  console.log("ALL MERGED:", mergedForSelected);
  console.log("Selected Type:", selectedType);
  console.log("subject object", mergedForSelected?.subjects?.[selectedSubjectIdx]);

  useEffect(() => {
    setSelectedType(null);
  }, [selectedSubjectIdx]);

 const getNumericSlug = (lecture = "") => {
  let value = "";

  if (typeof lecture === "string") {
    value = lecture;
  } else if (typeof lecture?.stableKey === "string") {
    value = lecture.stableKey;
  } else if (typeof lecture?.title === "string") {
    value = lecture.title;
  } else if (typeof lecture?.title?.title === "string") {
    value = lecture.title.title;
  }

  const match = value.match(/(\d+)[.-](\d+)[.-](\d+)/);

  return match
    ? `${match[1]}-${match[2]}-${match[3]}`
    : "";
};

  const getLectureTitle = (lecture) => {
  if (typeof lecture === "string") {
    return lecture;
  }

  if (typeof lecture?.title === "string") {
    return lecture.title;
  }

  if (typeof lecture?.title?.title === "string") {
    return lecture.title.title;
  }

  return "";
};

  return (
    <div className="course-page coursehtml">
      <div className="content-section">
        <div className="white-frame">
        <div className="white-frame__content">
          <div className="location-fav">
            <img src={Favlogo} alt="fav" className="fav-icon" />
            <span className="location-separator">|</span>
            <span className="location-text">{t('courses')}</span>
          </div>
          <div className="content-profile">
              <h1>{t('level')?.toUpperCase()} <strong>{userLevelContent?.title?.toUpperCase()}</strong></h1>
          </div>
          <div className="content-info">
              <ul className="contentItems-list">
                  {levelData.map((item, idx) => (
                    <li key={idx} className={`contentItems-item ${selectedSubjectIdx === idx ? "active" : ""}`}
                        onClick={() => { setSelectedSubjectIdx(idx); setSelectedType(null); }}>
                        <img src={arrowRight} alt="" className="arrow-icon1" />{item?.toUpperCase()}
                    </li>
                  ))}     
              </ul>
          </div>
          {/* LEFT PANEL */}
          <div className="map-content-panel">
            {selectedSubjectIdx === null && (
              <div className="center-image"><img src={placeholderMain} alt="select course" /></div>
            )}
            {selectedSubjectIdx !== null && mergedForSelected && (
              <div className="subject-content-wrapper">
                <div className="subject-column">
                  {(() => {
                    const subject = mergedForSelected.subjects[selectedSubjectIdx];
                    return (
                      <div className="subject-block">
                        <div className="subject-title1">{subject.title}</div>
                        <div className="subject-sections">
                          {subject.lectures?.length > 0 && (
                            <div  className={`section-link ${selectedType === "Lessons" ? "selected" : ""}`}
                                  onClick={() =>  setSelectedType("Lessons")}>
                                {t("lessons")}
                            </div>
                          )}
                          <div className={`section-link ${selectedType === "Documents" ? "selected" : ""}`}
                              onClick={() => navigate(`/course/${courseSlug}/docs`)}>
                            {t("ebooks")}
                          </div>
                        </div>
                      </div>
                    )
                  })()}
                </div>
                {/* L PANEL */}
                <div className="content-column">
                  {!selectedType && (<div className="center-image"> <img src={placeholderSide} alt="choose type" /></div>)}

                  {selectedType && (
                    <div className="content-list">
                     {selectedType === "Lessons" &&
  mergedForSelected.subjects[selectedSubjectIdx].lectures?.map(
    (lecture, i) => {
      const lectureTitle = getLectureTitle(lecture);
      const lectureSlug = getNumericSlug(lecture);

      const isCompleted = courseProgress.some(
  progress =>
    progress.lessonSlug === lectureSlug &&
    progress.status === "completed"
);

      return (
        <div
          key={lecture.stableKey || lectureSlug || i}
          className="lecture-item-content"
        >
          <LectureProgressItem
            title={lectureTitle}
            realTitle={lecture.stableKey || lectureTitle}
            to={`/course/${courseSlug}/lectures/${lectureSlug}`}
            allowToggle={false}
            isCompleted={isCompleted}
          />
        </div>
      );
    }
  )}

                      {selectedType === "Documents" &&
                        mergedForSelected.subjects[selectedSubjectIdx].docs?.map((doc, i) => (
                          <div key={i}> <Link to={`/docs/${slugify(doc)}`}>{t(doc)}</Link> </div>
                        ))}

                    </div>
                  )}

                </div>
              </div>
            )}
          </div>
        </div>
        </div>
      </div>
    </div>
  )
}

export default Content;
